module.exports = __webpack_public_path__ + "static/media/public.jwt.aca9053b.pem";